import { useTranslation } from "next-i18next";
import { useMemo } from "react";
import { useTable } from "react-table";

const CorporateEmailTable = ({ data }) => {
    const { t } = useTranslation(["common", "email"]);

    const columns = useMemo(() => [
        {
            Header: t("email:features"),
            accessor: "properties",
        },
        {
            Header: "Yandex Mail",
            accessor: "yandexmail"

        },
        {
            Header: "Gmail",
            accessor: "gmail"
        },
        {
            Header: "Makdos",
            accessor: "makdos"

        }
    ], []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data });

    return (
        <table {...getTableProps()} className="w-full">
            <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th
                                {...column.getHeaderProps()}
                                className="p-3 text-sm text-left bg-makdosTitleDiv text-textWhite whitespace-nowrap"
                            >
                                {column.render("Header")}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row, index) => {
                    prepareRow(row);
                    return (
                        <tr {...row.getRowProps()} className={index % 2 === 0 ? " bg-white p-3" : " bg-makdosSecondaryGray p-3"}>
                            {row.cells.map(cell => {
                                return (
                                    <td {...cell.getCellProps()} className="p-3 whitespace-nowrap">
                                        {cell.render("Cell")}
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    )
}

export default CorporateEmailTable